export const HEADER_BUTTONS = {
  signIn: 'Sign in',
  startYourDebate: 'Start a debate',
  about: 'About',
  toDebates: 'To debates',
  createWithAI: 'Create topic with AI',
} as const;

export const BACK_TO_DEBATES = 'Return to debate feed' as const;

export const CLOSE = 'Close' as const;

export const CHALLENGE_CARD_BUTTONS = {
  mainButton: {
    regularUser: 'Accept',
  },
} as const;

export const DEBATE_CARD_BUTTONS = {
  mainButton: {
    startDebate: 'Start debate',
    joinDebate: 'Join debate',
    watchDebate: 'Watch debate',
  },
  mainButtonHoverPrompt: 'The debate stream is about to start',
} as const;

export const CARD_COMMON_BUTTONS = {
  buttonReadMore: 'Read more',
  buttonReadLess: 'Read less',
} as const;

export const FORMS_BUTTON = {
  registrationSubmitButton: 'Sign up',
  loginSubmitButton: 'Sign in',
  forgotPasswordButton: 'Forgot your password?',
  createDebateSubmitButton: 'Create challenge',
  changePasswordConfirmButton: 'Change password',
  changePasswordCancelButton: 'Go back',
  enterEmailSubmitButton: 'Send',
  passwordRecoverySubmitButton: 'Change password',
  profileChangePasswordModalOpenButton: 'Change password',
  profileSubmitButton: 'Save changes',
} as const;
